import styled from 'styled-components';

const BoxTitle = styled.div`
  display: inline-block;
  vertical-align: middle;
  height: 100%;
  line-height: 28px;
  font-weight: bold;
  font-size: smaller;
  margin: auto;
`;

export default BoxTitle;
